import React from 'react';
import { NavLink } from 'react-router-dom';
import '../../styles/navbar.css';
import { connect } from 'react-redux';

function NavBar(state) {
  const isLoggedIn = state.isLoggedIn;
  const user = state.user;

  const handleLogout = () => {
    localStorage.removeItem('user');
    window.location.reload();
  }

  return (
    <nav className="navbar">
      {isLoggedIn && <span>Hi, {user.username}!</span>}
      <NavLink
        className={navData =>
          navData.isActive ? 'navbar__link--active' : 'navbar__link'
        }
        to="/"
      >
        Home
      </NavLink>

      {isLoggedIn && (
        <NavLink
          className="navbar__link"
          onClick={handleLogout}
          >
          Logout
        </NavLink>
      )}

      {!isLoggedIn && (
        <>
          <NavLink
            className={navData =>
              navData.isActive ? 'navbar__link--active' : 'navbar__link'
            }
            to="/login"
          >
            Login
          </NavLink>
          <NavLink
            className={(navData) => (navData.isActive ? "navbar__link--active" : "navbar__link")}
            to="/signup"
            >
            Sign Up
          </NavLink>
        </>
      )}
    </nav>
  );
}

const mapStateToProps = function (state) {
  return {
    user: state.userReducer.user,
    isLoggedIn: state.userReducer.isLoggedIn,
  };
};

export default connect(mapStateToProps)(NavBar);
